export const errorMessages = {
  UI_ERROR_MESSAGE: 'Could not display application window due to UI error.',
  CUSTOMER_DATA_ERROR_MESSAGE: 'Fetching user data failed.',
  USER_PERMISSIONS_ERROR_MESSAGE: 'Fetching user permissions failed.',
};

export const REFRESH_PAGE_MESSAGE =
  'Try refreshing the page and if the problem persists please contact technical support.';
